import axios from "axios";

// "Më të lexuara" — hits the backend /api/most-read endpoint, which is fed by
// the GA4 Data API on the server side (see news-aggregator-api).
//
// Backend returns: [{ title, link, views }, ...]
//   - `link` is an internal path like "/category/Bota/cluster/123"
//   - empty array if GA isn't wired up yet → we surface FALLBACK below.

const FALLBACK = [
  { title: "Përmbledhja e javës: çfarë lëvizi tregjet rajonale", link: null },
  { title: "Pesë gjërat që duhet të dini nga politika sot", link: null },
  { title: "Sport: rivaliteti që po rikthen tifozët në stadium", link: null },
  { title: "Kulturë: ngjarjet kryesore të javës që po vjen", link: null },
];

export const fetchMostRead = async () => {
  // Generous timeout + one retry to survive Render free-tier cold starts
  // (first request after idle can take 30-50s to wake the API).
  const attempt = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/api/most-read`, {
      timeout: 45000,
    });

  for (let i = 0; i < 2; i++) {
    try {
      const res = await attempt();
      const list = Array.isArray(res.data) ? res.data : [];
      return list.length > 0 ? list : FALLBACK;
    } catch (err) {
      if (i === 1) {
        console.warn("most-read fetch failed, using placeholder:", err.message);
        return FALLBACK;
      }
      await new Promise((r) => setTimeout(r, 1500));
    }
  }
  return FALLBACK;
};
